// Lightweight counts so pages can show totals without loading the corpus.
export const NOTARY_FAQ_COUNT_TH = 240;
export const NOTARY_FAQ_COUNT_EN = 250;
